/**
 * Converts SimpleFin accounts into grouped select options organized by financial institution.
 * Each account is grouped under its organization name and the groups are sorted alphabetically.
 *
 * @param accounts - Array of SimpleFin accounts to convert
 * @returns Array of option groups, each containing a label (org name) and its account options
 *
 * @example
 * const accounts = [
 *   { simpleFinId: '1', name: 'Checking', orgName: 'Chase' },
 *   { simpleFinId: '2', name: 'Savings', orgName: 'Chase' },
 *   { simpleFinId: '3', name: 'Credit Card', orgName: 'Amex' }
 * ];
 *
 * // Returns:
 * // [
 * //   {
 * //     label: 'Amex',
 * //     options: [{ value: '3', label: 'Credit Card' }]
 * //   },
 * //   {
 * //     label: 'Chase',
 * //     options: [
 * //       { value: '1', label: 'Checking' },
 * //       { value: '2', label: 'Savings' }
 * //     ]
 * //   }
 * // ]
 */
export const getSimpleFinAccountOptions = (accounts) => {
    const grouped = accounts.reduce((acc, account) => {
        const group = acc.find((g) => g.label === account.orgName);
        const option = {
            value: account.id,
            label: account.name,
            aside: account.balance,
        };
        if (group) {
            group.options.push(option);
        }
        else {
            acc.push({
                label: account.orgName,
                options: [option],
            });
        }
        return acc;
    }, []);
    // Sort items within each group by label
    grouped.forEach((group) => {
        group.options.sort((a, b) => a.label.localeCompare(b.label));
    });
    // Sort groups by organization name
    return grouped.sort((a, b) => a.label.localeCompare(b.label));
};
